import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import 'Components/Blog/BlogCategories.scss';

const BlogCategories = ({ category }) =>
  <div className="container">
    <nav aria-label="blog-navigation" className={`blog-categories-container ${window.location.pathname === '/en/blog' ? '' : 'blog-category-dummy-top'}`}>
      <div className={`blog-category ${category === '' ? 'active-category' : ''}`}>
        <Link to="/blog">
          <FormattedMessage id="blog.categories.Home" defaultMessage="Home" />
        </Link>
      </div>
      <div className={`blog-category ${category === 'games' ? 'active-category' : ''}`}>
        <Link to="/blog/category/games">
          <FormattedMessage id="blog.categories.games" defaultMessage="Games" />
        </Link>
      </div>
      <div className={`blog-category ${category === 'news' ? 'active-category' : ''}`}>
        <Link to="/blog/category/news">
          <FormattedMessage id="blog.categories.news" defaultMessage="News" />
        </Link>
      </div>
      <div className={`blog-category ${category === 'develop' ? 'active-category' : ''}`}>
        <Link to="/blog/category/develop">
          <FormattedMessage id="blog.categories.develop" defaultMessage="Develop" />
        </Link>
      </div>
      <div className="blog-category no-border">
        <a href="https://fant.cl/Discord" target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="blog.categories.community" defaultMessage="Community" />
        </a>
      </div>
    </nav>

    {!category &&
      <div className="blog-blurb">
        <FormattedMessage
          id="blog.categories.blurb"
          defaultMessage="Written by gamers, for gamers, get regular updates on the latest gaming news with the Fanatical Blog. Jam-packed with content goodness, our blog features contests and details on the latest sales, as well as interviews with some of the industry's top publishers and developers, eBooks and tech news, guides and much more!"
        />
      </div>
    }
  </div>;

BlogCategories.propTypes = {
  category: PropTypes.string,
};

BlogCategories.defaultProps = {
  category: '',
};

export default BlogCategories;
